export const TokenValidationLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00a389] mx-auto"></div>
      <p className="mt-4 text-gray-600">Vérification du lien...</p>
    </div>
  </div>
);

export const TokenValidationError = ({ onRetry }) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
      <h2 className="text-2xl font-bold text-red-600 mb-4">Lien invalide</h2>
      <p className="text-gray-600 mb-6">
        Ce lien de réinitialisation est invalide ou a expiré. Veuillez demander un nouveau lien.
      </p>
      <button
        onClick={onRetry}
        className="w-full rounded-full bg-[#00a389] py-3 text-base font-semibold text-white shadow-[0_12px_24px_rgba(0,163,137,0.25)] transition hover:bg-[#00967d]"
      >
        Demander un nouveau lien de réinitialisation
      </button>
    </div>
  </div>
);
